<div *ngIf="toastDetails" class="toast" [ngClass]="'toast--' + severity" @fade>
  <div class="toast__details">
    <img *ngIf="getIconPath()" [src]="getIconPath()"/>
    <div class="toast__details-text">
      <p class="toast__header">{{ toastDetails.header }}</p>
      <span *ngIf="toastDetails.message" class="toast__text" [innerHTML]="toastDetails.message | sanitizeHtml"></span>
    </div>
    <i class="material-icons toast__close" (click)="onClose()">close</i>
  </div>
</div>
